import { render, staticRenderFns } from "./LAB_DNA_READY.vue?vue&type=template&id=816b3b70&"
import script from "./LAB_DNA_READY.vue?vue&type=script&lang=js&"
export * from "./LAB_DNA_READY.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports